import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-m-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_ctx.error)
    ? (_openBlock(), _createBlock(_component_Dialog, {
        key: 0,
        class: "error-dialog",
        header: _ctx.error.title,
        closable: false,
        visible: _ctx.displayModal,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayModal) = $event)),
        style: { width: '50vw' },
        modal: true
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "OK",
            icon: "pi pi-check",
            onClick: _ctx.closeModal
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.error.message), 1)
          ])
        ]),
        _: 1
      }, 8, ["header", "visible"]))
    : _createCommentVNode("", true)
}